import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  // 기존
  // {
  //   path: "/",
  //   component: () => import("@/page/AITutoring/Index"),
  //   meta: {
  //     title: "aitutoring",
  //   },
  // },
  // {
  //   path: "/payment",
  //   component: () => import("@/page/AITutoring/Payment"),
  //   meta: {
  //     title: "payment",
  //   },
  // },
  // {
  //   path: "/faq",
  //   component: () => import("@/page/AITutoring/Faq"),
  //   meta: {
  //     title: "faq",
  //   },
  // },
  // {
  //   path: "/privacy",
  //   component: () => import("@/page/AITutoring/Privacy"),
  //   meta: {
  //     title: "privacy",
  //   },
  // },
  // {
  //   path: "/terms",
  //   component: () => import("@/page/AITutoring/Terms"),
  //   meta: {
  //     title: "terms",
  //   },
  // },

  // 리뉴얼
  {
    path: "/",
    component: () => import("@/page/AiTutorPlus/Index"),
    meta: {
      title: "AI Tutor Plus",
    },
  },
  {
    path: "/PrivacyPolicy",
    component: () => import("@/page/AiTutorPlus/PrivacyPolicy"),
    meta: {
      title: "개인정보처리방침",
    },
  },
  {
    path: "/TermsOfUse",
    component: () => import("@/page/AiTutorPlus/TermsOfUse"),
    meta: {
      title: "이용약관",
    },
  },
];

const aitutoring = new VueRouter({
  mode: "history",
  routes,
});

aitutoring.afterEach((to, from) => {
  const title = to.meta.title === undefined ? "CarrotSolutions" : to.meta.title;
  Vue.nextTick(() => {
    document.title = title;
  });
});

export default aitutoring;
